module.exports = __webpack_public_path__ + "img/logo.91598756.png";